import { RoundTo } from "@pdfking/math"

import type { QuantitySpec } from "#public"

/** Round a standard-unit value to its spec's `precision`. The float dust is
 * cleared first (6 decimals past it), so the same value reached two ways —
 * `1234.4999999998` and `1234.5000000001` — lands on the same side of the half. */
export const Quantize = <T extends number>(value: T, spec: QuantitySpec<T>): T =>
  RoundTo(RoundTo(value, spec.precision + 6), spec.precision)
